<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-demo__advertoauth}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.advertPlatformAccountId" placeholder="账号id" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.accountName" placeholder="账号名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.status" filterable  clearable placeholder="请选择授权状态">
            <el-option
                    v-for="item in status"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
                  v-model="date"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :default-time="['00:00:00', '23:59:59']"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  @change="getTimes">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
<!--        <el-form-item>-->
<!--          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>-->
<!--        </el-form-item>-->
        <el-form-item>
          <el-button v-if="$hasPermission('sys:advertoauth:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:advertoauth:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="id" label="id" header-align="center" align="center"></el-table-column>
        <el-table-column prop="advertPlatformAccountId" label="账号ID" header-align="center" align="center"></el-table-column>
        <el-table-column prop="accountName" label="账号名称" header-align="center" align="center"></el-table-column>
<!--        <el-table-column prop="advertPlatform" label="所属广告平台" header-align="center" align="center"></el-table-column>-->
        <el-table-column prop="status" label="授权状态" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === 'INIT'" size="small">未授权</el-tag>
            <el-tag v-if="scope.row.status === 'PROCESSING'" size="small">授权中</el-tag>
            <el-tag v-if="scope.row.status === 'SUCCESS'" size="small">授权成功</el-tag>
            <el-tag v-if="scope.row.status === 'FAILED'" size="small">授权失败</el-tag>
            <el-tag v-if="scope.row.status === 'INVALID'" size="small">失效</el-tag>
          </template>
        </el-table-column>
<!--        <el-table-column prop="accessToken" label="access_token" header-align="center" align="center"></el-table-column>-->
<!--        <el-table-column prop="refreshToken" label="refresh_token" header-align="center" align="center"></el-table-column>-->
<!--        <el-table-column prop="accessTokenExpiresIn" label="access_token有效时间（毫秒）" header-align="center" align="center"></el-table-column>-->
<!--        <el-table-column prop="refreshTokenExpiresIn" label="refresh_token有效时间（毫秒）" header-align="center" align="center"></el-table-column>-->
<!--        <el-table-column prop="accessTokenExpireTime" label="access_token过期时间" header-align="center" align="center"></el-table-column>-->
<!--        <el-table-column prop="refreshTokenExpireTime" label="refresh_token过期时间" header-align="center" align="center"></el-table-column>-->
<!--        <el-table-column prop="authorizerInfo" label="授权返回结果" header-align="center" align="center"></el-table-column>-->
<!--        <el-table-column prop="createdBy" label="创建人" header-align="center" align="center"></el-table-column>-->
<!--        <el-table-column prop="updatedBy" label="修改人" header-align="center" align="center"></el-table-column>-->
        <el-table-column prop="createTime" label="创建时间" header-align="center" align="center"></el-table-column>
<!--        <el-table-column prop="updateTime" label="修改时间" header-align="center" align="center"></el-table-column>-->
<!--        <el-table-column prop="deleteTime" label="删除时间" header-align="center" align="center"></el-table-column>-->
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('sys:advertoauth:update') && scope.row.status!='SUCCESS' && scope.row.status!='PROCESSING'" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('sys:advertoauth:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
            <el-button v-if="$hasPermission('sys:advertoauth:grant') && scope.row.status!='SUCCESS' && scope.row.status!='PROCESSING'" type="text" size="small" @click="grantHandle(scope.row.id)">授权</el-button>
            <el-button v-if="$hasPermission('sys:advertoauth:cancel') && scope.row.status=='SUCCESS'" type="text" size="small" @click="cancelHandle(scope.row.id)">撤销</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
      <operate-auth v-if="addOrUpdateVisible" ref="operateOauth" @refreshDataList="getDataList"></operate-auth>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './advertoauth-add-or-update'
import OperateAuth from './advertoauth-operate'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      addOrUpdateVisible: false,
      url:"",
      date:'',
      status:[
      {
        'label':'未授权',
        'value':'INIT',
      },
      {
        'label':'授权中',
        'value':'PROCESSING',
      },
      {
        'label':'授权成功',
        'value':'SUCCESS',
      },
      {
        'label':'授权失败',
        'value':'FAILED',
      },
      {
        'label':'失效',
        'value':'INVALID',
      }
    ],
      mixinViewModuleOptions: {
        getDataListURL: '/sys/advertoauth/page',
        getDataListIsPage: true,
        exportURL: '/sys/advertoauth/export',
        deleteURL: '/sys/advertoauth',
        deleteIsBatch: true
      },
      dataForm: {
        id: '',
        advertPlatformAccountId: '',
        accountName: '',
        startDate: '',
        endDate: '',
        status:'',
        auth_code: '',
        state: ''
      }
    }
  },
  created () {
    let state = this.$route.query.state
    let auth_code = this.$route.query.auth_code
    if ((state != null && auth_code != null)) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
        target: document.querySelector('.div1')
      });
      this.$http.get(`/sys/advertoauth/getToken?auth_code=` + auth_code + '&state=' + state).then(({data: res}) => {
        if (res.code !== 0) {
          loading.close();
          return this.$message.error(res.msg)
        }
        this.$message({
          message: this.$t('prompt.success'),
          type: '授权成功',
          duration: 500,
          onClose: () => {
            loading.close();
            this.$route.query.state=null;
            this.$route.query.auth_code=null;
            this.query()
            this.visible = false
            this.$router.replace({
              path: "sys-advertoauth"
            });
          }
        })
      }).catch(() => {
      })
    }else{
      if (this.mixinViewModuleOptions.createdIsNeed) {
        // this.query()
      }
    }
  },
  methods:{
    grantHandle (id) {
      this.$http.get(`/sys/advertoauth/grant?id=`+id).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.url = res.data;
        window.location.href = res.data
      }).catch(() => {})
      /*this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.operateOauth.dataForm.url = this.url;
        this.$refs.operateOauth.init()
      })*/
    },
    cancelHandle (id) {
      this.$http.get(`/sys/advertoauth/cancel?id=`+id).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.$message({
          message: this.$t('prompt.success'),
          type: 'success',
          duration: 500,
          onClose: () => {
            this.query()
          }
        })
      }).catch(() => {})
    },
    //利⽤change事件监听表单内容变化，并将选中的值赋值给所需要的两个字段
    //⽀付时间戳设置
    getTimes() {
      if (this.date != null) {
        this.dataForm.startDate = this.date[0]
        this.dataForm.endDate = this.date[1]
      }else{
        this.dataForm.startDate =''
        this.dataForm.endDate = ''
      }
    }
  },
  components: {
    AddOrUpdate,
    OperateAuth
  }
}
</script>
